const lessonPlans = {
  // Page meta
  pageTitle: 'Lesson Plan',
  pageSubtitle: 'Design and structure a personalised lesson plan',
  backToDashboard: 'Back to Dashboard',
  // Form sections
  planSettings: 'Plan Settings',
  planType: 'Plan Type',
  individual: 'Individual',
  group: 'Group',
  targetStudents: 'Target Student(s)',
  selectStudents: 'Select students...',
  noStudentsFound: 'No students found',
  selectedCount: '{{count}} selected',
  dateRange: 'Date Range',
  startDate: 'Start Date',
  endDate: 'End Date',
  themeTopic: 'Theme / Unit Topic',
  themePlaceholder: 'e.g., Community Helpers, Fall Season',
  themeHelper: 'Contextualises the learning environment',
  // Skill, Goal & Objective
  skillGoalSection: 'Skill, Goal and Objective Selection',
  skillDomain: 'Skill / Domain',
  skillDomainDesc: 'Select all primary developmental areas targeted',
  noSkillsSelected: 'No skills selected',
  goalsAndTargets: 'Goals and Targets',
  longTermGoal: 'Long-Term Goal',
  longTermGoalPlaceholder: 'e.g., The student will independently manage personal hygiene routine by the end of term.',
  shortTermObjective: 'Short-Term Objective',
  shortTermObjectivePlaceholder: 'e.g., Student will wash hands with verbal prompts only, 4 out of 5 times.',
  // Learning Profiles
  learningProfiles: 'Learning Profiles and Resources',
  learningStylesTargeted: 'Learning Styles Targeted',
  learningStylesDesc: 'Select approaches that best support the student(s)',
  noStylesSelected: 'No learning styles selected',
  tlmMaterials: 'Teaching &amp; Learning Materials (TLM)',
  tlmDesc: 'Select standard materials and add custom items',
  standardMaterials: 'Standard Materials',
  customMaterials: 'Custom Materials',
  addCustomMaterial: 'Type and press Enter to add',
  noMaterialsSelected: 'No materials selected',
  // Procedure Steps
  procedureSection: 'Multi-Step Procedure',
  procedureDesc: 'Break tasks down into micro-steps (Task Analysis)',
  addStep: 'Add Step',
  removeStep: 'Remove Step',
  stepNumber: 'Step {{number}}',
  stepTitle: 'Step Title',
  stepTitlePlaceholder: 'e.g., Warm-up / Attending',
  educatorAction: 'Educator Action',
  educatorActionPlaceholder: 'What the teacher says or does...',
  studentExpectation: 'Student Expectation',
  studentExpectationPlaceholder: 'How the student should respond...',
  promptHierarchy: 'Prompt Hierarchy Level',
  noProcedureSteps: 'No procedure steps added yet. Click "Add Step" to begin.',
  // Evaluation & Tracking
  evaluationSection: 'Evaluation and Tracking',
  evaluationDesc: 'Track multiple specific behaviours or milestones within this lesson',
  addMetric: 'Add Metric',
  removeMetric: 'Remove Metric',
  metricNumber: 'Metric {{number}}',
  targetBehavior: 'Target Behaviour',
  targetBehaviorPlaceholder: 'e.g., Eye contact, correct sorting',
  measurementCriteria: 'Measurement Criteria',
  successThreshold: 'Success Threshold',
  successThresholdPlaceholder: 'e.g., 80% accuracy over 3 consecutive days',
  noEvaluationMetrics: 'No evaluation metrics added yet. Click "Add Metric" to begin.',
  // Continuity & Review
  continuitySection: 'Continuity and Final Review',
  followUpPlan: 'Follow-Up Plan',
  followUpPlanPlaceholder: 'Strategies for generalisation across settings, home reinforcement activities, or next logical pedagogical steps...',
  finalEvaluation: 'Final Evaluation / Session Notes',
  finalEvaluationDesc: 'To be filled after the lesson is conducted',
  finalEvaluationPlaceholder: 'Capture what worked, unexpected sensory triggers, and overall engagement notes...',
  // Actions
  saveDraft: 'Save Draft',
  submitPlan: 'Submit Lesson Plan',
  planSavedDraft: 'Lesson plan saved as draft!',
  planSubmitted: 'Lesson plan submitted successfully!',
  // Validation
  validationSelectStudents: 'Please select at least one student',
  validationDateRange: 'Please select both start and end dates',
  validationTheme: 'Theme / unit topic is required',
  validationSkillDomain: 'Please select at least one skill domain',
  validationLongTermGoal: 'Long-term goal is required',
  validationShortTermObjective: 'Short-term objective is required',
  validationLearningStyles: 'Please select at least one learning style',
  validationProcedureSteps: 'Please add at least one procedure step',
  // Lesson Plan List
  listPageTitle: 'My Lesson Plans',
  listPageSubtitle: 'View, manage, and track all your lesson plans',
  newPlan: 'New Lesson Plan',
  saveAsTemplate: 'Save as Template',
  saveAsTemplateTitle: 'Save as Template',
  templateName: 'Template Name',
  templateNamePlaceholder: 'e.g., Morning Routine Plan',
  templateSaved: 'Template saved successfully!',
  planTypeIndividual: 'Individual',
  planTypeGroup: 'Group',
  statusSubmitted: 'Submitted',
  statusInProgress: 'In Progress',
  statusCompleted: 'Completed',
  noLessonPlans: 'No lesson plans yet',
  noLessonPlansDesc: 'Create your first lesson plan to get started.',
  noTemplates: 'No templates saved yet',
  noTemplatesDesc: 'Save a lesson plan as a template to reuse it later.',
  searchPlans: 'Search lesson plans...',
  filterByStatus: 'Filter by status',
  allPlans: 'All Plans',
  myTemplates: 'My Templates',
  duplicatePlan: 'Duplicate',
  deletePlan: 'Delete Plan',
  deletePlanConfirm: 'Are you sure you want to delete this lesson plan?',
  planDeleted: 'Lesson plan deleted',
  planDuplicated: 'Lesson plan duplicated',
  useTemplate: 'Use Template',
  stepsCount: '{{count}} steps',
  metricsCount: '{{count}} metrics',
  skillsCount: '{{count}} skills',
};

export default lessonPlans;